import React, {ReactNode, useEffect, useState} from 'react';
import {$router, useRouteChange} from "./Index";
import {checkMatchModel} from "./tools";

type IProps = {
    children: ReactNode
}
export default function Switch(props: IProps) {
    const { pathname } = useRouteChange();
    const [element, setElement] = useState<any>(null);
    const [elementNode, setElementNode] = useState<any>(null);

    useEffect(() => {
        let match = false;
        let el_node: any = null;
        document.documentElement.scrollTop = 0;
        React.Children.forEach( props.children ,async (item: any) => {
            let matchPath = item.props.path === pathname || (!item.props.exact && pathname.startsWith(item.props.path));
            /* :xxx Pattern Matching Routing */
            let { isMatchModel } = checkMatchModel(item.props.path, pathname);
            if (!match && (matchPath || isMatchModel)) {
                match = true;
                $router.meta = item.props.meta || {};
                if (item.props.beforeRender) {
                    await item.props.beforeRender();
                }

                el_node = item;
                setElementNode(item);
            }
            if (!match && item.props.to) {
                el_node = item;
                setElementNode(item);
            }
        });
        // Avoid duplicate rendering
        /*if (!element || (el_node && element.key !== el_node.key)) {
            setElement(el_node);
        }*/
        // return el_node;
    }, [pathname, element]);

    useEffect(() => {
        if (!element || (elementNode && element.key !== elementNode.key)) {
            setElement(elementNode);
        }
    }, [element, elementNode]);

    return <>
        {element ? React.cloneElement(element) : null }
    </>
}
